"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSigningRequest = void 0;
const zlib_1 = __importDefault(require("zlib"));
const eosjs_1 = require("eosjs");
const eosjs_jssig_1 = require("eosjs/dist/eosjs-jssig");
const eosio_signing_request_1 = require("eosio-signing-request");
const poly_fill_1 = require("./utils/poly-fill");
exports.createSigningRequest = async (actions, rpc, options = {}) => {
    const eos = new eosjs_1.Api({
        rpc,
        textDecoder: poly_fill_1.textDecoder,
        textEncoder: poly_fill_1.textEncoder,
        signatureProvider: new eosjs_jssig_1.JsSignatureProvider([]),
    });
    // options for the signing request
    const opts = Object.assign({ 
        // string encoder
        textEncoder: poly_fill_1.textEncoder,
        // string decoder
        textDecoder: poly_fill_1.textDecoder, 
        // zlib string compression (optional, recommended)
        zlib: {
            deflateRaw: (data) => new Uint8Array(zlib_1.default.deflateRawSync(Buffer.from(data))),
            inflateRaw: (data) => new Uint8Array(zlib_1.default.inflateRawSync(Buffer.from(data))),
        }, 
        // Customizable ABI Provider used to retrieve contract data
        abiProvider: {
            getAbi: async (account) => eos.getAbi(account),
        } }, options);
    const request = await eosio_signing_request_1.SigningRequest.create({ actions }, opts);
    return request;
};
